// extracted by mini-css-extract-plugin
export default {"DataItem":"data-item_DataItem__IKuTw","DataCard":"data-item_DataCard__TFTD1"};